"use client";

import { Fragment, useEffect, useRef, useState } from "react";
import {
  Box,
  Checkbox,
  Grid,
  Typography,
  Divider,
  InputAdornment,
  IconButton,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";

import Colors from "assets/Style/Colors";
import { FontFamily } from "assets";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import AuthServices from "services/Auth";
import SystemServices from "services/System";
import { useForm } from "react-hook-form";
import InputField from "components/Input";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  CleanTypes,
  emailRegex,
  encryptData,
  getFileSize,
  nameRegex,
  passwordRegex,
} from "utils";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import InputPhone from "components/InputPhone";
import instance from "config/axios";
import routes from "services/System/routes";
import UploadFile from "components/UploadFile";
import Uploading from "components/Uploading";
import TermsConditions from "components/TermsConditions";
import DatePicker from "components/DatePicker";
import UserServices from "services/User";
import ConfirmationDialog from "components/Dialog/ConfirmationDialog";
import moment from "moment";
import CustomerServices from "services/Customer";

function EditCustomer() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const viewerRef = useRef();
  const { state } = useLocation();
  const customer = state?.item;
  console.log(state, "statestate");
  const baseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    control,
    setValue,
  } = useForm();
  console.log(errors, "errorserrors");

  const [ShowRadio, setShowRadio] = useState(false);
  const [radiovalue, setradiovalue] = useState("2");
  const password = useRef({});
  password.current = watch("password", "");
  const [loading, setLoading] = useState(false);

  const allowFilesType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "application/pdf",
  ];
  const allowOnlyImage = ["image/png", "image/jpg", "image/jpeg"];

  const [customerTypes, setCustomerTypes] = useState(true);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [permission, setPermission] = useState(false);

  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedBusinessCountry, setSelectedBusinessCountry] = useState([]);
  const [intCode, setIntCode] = useState();

  const [progress, setProgress] = useState(0);
  const [uploadedSize, setUploadedSize] = useState(0);
  const [documentsDetail, setDocumentsDetail] = useState([]);
  const [uploadedDocuments, setUploadedDocuments] = useState([]);

  const [progress4, setProgress4] = useState(0);
  const [uploadedSize4, setUploadedSize4] = useState(0);
  const [passportDetail, setPassportDetail] = useState([]);
  const [passportLink, setPassportLink] = useState("");
  const [pictureDetail, setPictureDetail] = useState([]);
  const [pictureLink, setPictureLink] = useState("");
  const [licenseDetail, setLicenseDetail] = useState([]);
  const [licenseLink, setLicenseLink] = useState("");
  const [certificateDetail, setCertificateDetail] = useState([]);
  const [certificateLink, setCertificateLink] = useState("");
  let params = useParams()

  const [userData, setUserData] = useState();
  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmationDialog, setConfirmationDialog] = useState(false);

  const [passportExp, setPassportExp] = useState(null);
  const [tradeExp, setTradeExp] = useState();
  const [vatExp, setVatExp] = useState();

  const [isAccept, setIsAccept] = useState(true);
  const [openTerms, setOpenTerms] = useState(false);

  const getCountries = async () => {
    try {
      const { data } = await SystemServices.getCountries();
      setCountries(data?.nations.rows);
    //   const selected = countries.find(
    //     (country) => country.id === customer?.customerProfile?.nationality_id
    //   );
  
    //   // Set the selected country (if found)
    //   if (selected) {
    //     setSelectedCountry(selected);
    //   }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getPermission = () => {
    Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        console.log("Notification permission granted.");
        localStorage.setItem("Permission", true);
        setPermission(true);
      } else {
        localStorage.setItem("Permission", false);
        setPermission(false);
      }
    });
  };

  const getCustomerDetail = async () => {
    try {
        let paramss = {
            customerID: params?.id,
        };

        const { data } = await CustomerServices.getCustomerDetail(paramss);
        let detail = data?.user;
        console.log(detail, 'detaildetail')
  
    } catch (error) {
        console.error("Error fetching location:", error);
    }
};

  const handleUploadDocument = async (e) => {
    try {
      e.preventDefault();
      const file = e.target.files[0];
      const obj = {
        id: uuidv4(),
        name: file?.name,
        file: "",
        type: file?.type.split("/")[1],
        size: getFileSize(file.size),
        isUpload: false,
      };
      if (allowFilesType.includes(file.type)) {
        setDocumentsDetail((prev) => [...prev, obj]);
        handleUpload(file, [...documentsDetail, obj], obj.id);
      } else {
        ErrorToaster(`Only ${CleanTypes(allowFilesType)} formats is supported`);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleUpload = async (file, docs, docId) => {
    setProgress(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
          setUploadedSize(getFileSize(uploadedBytes));
        },
      });
      if (data) {
        const index = docs.findIndex((doc) => doc.id === docId);
        docs[index].isUpload = true;
        docs[index].file = data?.data?.nations;
        setDocumentsDetail(docs);
        const documentsLinks = [...uploadedDocuments, data?.data?.nations];
        setUploadedDocuments(documentsLinks);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const removeDoc = (index) => {
    try {
      const updateDocDetail = [...documentsDetail];
      updateDocDetail.splice(index, 1);
      const updateDocLink = [...uploadedDocuments];
      updateDocLink.splice(index, 1);
      setDocumentsDetail(updateDocDetail);
      setUploadedDocuments(updateDocLink);
      setValue("document", "");
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handlePassportDate = (newDate) => {
    console.log(newDate, "newDatenewDate");
    try {
      if (!newDate || isNaN(new Date(newDate).getTime())) {
        setPassportExp("invalid");
        return;
      }
      setPassportExp(newDate);
      setValue("passportExp", newDate);
    } catch (error) {
      ErrorToaster(error);
    }
  };
  

  const handleTradeDate = (newDate) => {
    try {
      if (newDate == "Invalid Date") {
        setTradeExp("invalid");
        return;
      }
      setTradeExp(newDate);
      setValue("tradeExp", newDate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleVatDate = (newDate) => {
    try {
      if (newDate == "Invalid Date") {
        setVatExp("invalid");
        return;
      }
      setVatExp(newDate);
      setValue("vatExp", newDate);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleUploadDocument4 = async (e, type) => {
    try {
      e.preventDefault();
      const file = e.target.files[0];
      const arr = [
        {
          name: file?.name,
          file: "",
          type: file?.type.split("/")[1],
          size: getFileSize(file.size),
          isUpload: false,
        },
      ];
      if (type !== "picture" && allowFilesType.includes(file.type)) {
        handleUpload4(file, arr, type);
        if (type === "passport") {
          setPassportDetail(arr);
        } else if (type === "license") {
          setLicenseDetail(arr);
        } else {
          setCertificateDetail(arr);
        }
      } else if (type === "picture" && allowOnlyImage.includes(file.type)) {
        setPictureDetail(arr);
        handleUpload4(file, arr, type);
      } else {
        ErrorToaster(
          `Only ${CleanTypes(
            type === "picture" ? allowOnlyImage : allowFilesType
          )} formats is supported`
        );
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleUpload4 = async (file, docs, type) => {
    setProgress4(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total
          );
          setProgress4(percentCompleted);
          setUploadedSize4(getFileSize(uploadedBytes));
        },
      });
      if (data) {
        docs[0].isUpload = true;
        docs[0].file = data?.data?.nations;
        if (type === "passport") {
          setPassportDetail(docs);
          setPassportLink(data?.data?.nations);
        } else if (type === "picture") {
          setPictureDetail(docs);
          setPictureLink(data?.data?.nations);
        } else if (type === "license") {
          setLicenseDetail(docs);
          setLicenseLink(data?.data?.nations);
        } else {
          setCertificateDetail(docs);
          setCertificateLink(data?.data?.nations);
        }
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const removeDoc4 = (type) => {
    try {
      if (type === "passport") {
        setPassportDetail([]);
        setPassportLink("");
        setValue("passport", "");
      } else if (type === "picture") {
        setPictureDetail([]);
        setPictureLink("");
        setValue("picture", "");
      } else if (type === "license") {
        setLicenseDetail([]);
        setLicenseLink("");
        setValue("license", "");
      } else {
        setCertificateDetail([]);
        setCertificateLink("");
        setValue("certificate", "");
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleAccountLinking = async () => {
    try {
      setConfirmationDialog(false);
      const obj = {
        business_region: customerTypes.businessRegion,
        uae_phone: userData?.uae_phone,
        email: userData?.email,
        screen: "link",
      };
      const { data, responseCode } = await AuthServices.Linking(obj);
      console.log(data);
      if (responseCode == 206) {
        const otpField = {
          emailField: data?.email,
          phoneField: data?.phone,
        };
        navigate("/verify-otp", { state: { ...obj, ...otpField } });
      }
    } catch (error) {
      console.log(error);
      ErrorToaster(error);
    }
  };
  useEffect(() => {
    if (customer?.picture) {
      const link = customer?.picture;
      setPictureDetail([
        {
          name: baseUrl + link,
          file: link,
          type: link.split(".").pop(),
          size: "",
          isUpload: true,
        },
      ]);
      setPictureLink(link);
    }

    if (customer?.customerProfile?.passport) {
      const link = customer.customerProfile.passport;
      setPassportDetail([
        {
          name: baseUrl + link,
          file: link,
          type: link.split(".").pop(),
          size: "",
          isUpload: true,
        },
      ]);
      setPassportLink(link);
    }
   

    setValue("customerName", customer?.name);
    setValue("email", customer?.email);
      setValue("trn", customer?.address);
    setValue("address", customer?.customerProfile?.address);
    setValue("mobile", customer?.uae_phone);
    setValue("apName", customer?.customerProfile?.ap_name);
    setValue("apDocumentName", customer?.customerProfile?.ap_document_name);
    setValue("apMobile", customer?.customerProfile?.ap_number);
    setPassportExp(new Date(customer?.customerProfile?.passport_expiry)); 
    setValue("passportExp", new Date(customer?.customerProfile?.passport_expiry));  
    setSelectedCountry(customer?.customerProfile?.nationality   )  
    setValue("nationality",customer?.customerProfile?.nationality   )  
  }, [customer]);

  const onSubmit = async (formData) => {
    setLoading(true);
    console.log(formData, "formData");

    try {
      const commonData = {
        user_id:params?.id,
        name: formData.customerName,
        nationality_id: selectedCountry?.id,
        uae_phone: formData?.mobile,

        email: formData?.email,

        passport: passportLink,

        passport_expiry: passportExp,
        address: formData?.address,
           trn: formData?.trn,
        currency: "aed",
        user_type_id: "C",
        ap_name: formData.apName,
        ap_number: formData.apMobile,
        ap_document_name: formData.apDocumentName,

        ap_document: uploadedDocuments.length > 0 ? uploadedDocuments : [],
        picture: pictureLink,

        business_region: "import",
        import: true,

        gender: "male",
        customer_type: 1,
      };

      console.log(commonData, "commonDatacommonData");
      const { message } = await UserServices.updateUser(commonData);
      SuccessToaster(message);
      navigate("/our-customers");
    } catch (error) {
      console.log(error);

      ErrorToaster(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCountries();
    getPermission();
    getCustomerDetail()
  }, []);

  return (
    <Fragment>
      <ConfirmationDialog
        open={confirmationDialog}
        onClose={() => setConfirmationDialog(false)}
        message={confirmMessage}
        action={handleAccountLinking}
      />
      <TermsConditions
        open={openTerms}
        close={() => {
          setOpenTerms(false);
          setIsAccept(true);
        }}
      />
      {/* {!customerTypes && (
        <CustomerType
          submit={(value) => {
            if (value.businessRegion === "Export" && value.customerType.id == "2") {
              setShowRadio(true)
            }
            setCustomerTypes(value)
          }}
        />
      )} */}
      {customerTypes && (
        <Grid container spacing={1} justifyContent={"space-between"}>
          <Grid item xs={12}>
            <Box sx={{ bgcolor: Colors.white, p: 4, borderRadius: "12px" }}>
              <Typography variant="h4" sx={{ color: Colors.charcoalGrey }}>
                Edit{" "}
                {customerTypes?.customerType?.label == "Individual"
                  ? "Customer"
                  : customerTypes?.customerType?.label}
              </Typography>

              <Divider sx={{ color: Colors.iron, my: 3 }} />
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <InputField
                      label={"Customer Name"}
                      placeholder={"Customer Name"}
                      inputProps={{ maxLength: 50 }}
                      error={errors?.customerName?.message}
                      register={register("customerName", {
                        required: "Please enter your name.",
                        pattern: {
                          value: nameRegex,
                          message: "Please enter valid name.",
                        },
                      })}
                    />
                  </Grid>
                  {ShowRadio && (
                    <Grid item xs={12} sm={12}>
                      <FormControl>
                        <RadioGroup
                          row
                          defaultValue={"2"}
                          onChange={(e) => {
                            setradiovalue(e.target.value);
                          }}
                        >
                          <FormControlLabel
                            sx={{ color: "#00000099" }}
                            value="1"
                            control={<Radio />}
                            label="Agent"
                          />
                          <FormControlLabel
                            sx={{ color: "#00000099" }}
                            value="2"
                            control={<Radio />}
                            label="Broker"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  )}
                  <Grid item xs={12} sm={6}>
                    <SelectField
                      label={"Nationality"}
                      options={countries}
                      selected={selectedCountry}
                      onSelect={(value) => setSelectedCountry(value)}
                      error={errors?.nationality?.message}
                      register={register("nationality", {
                        required: "Please select nationality.",
                      })}
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <SelectField
                      multiple={true}
                      label={"Business Countries"}
                      options={countries}
                      selected={selectedBusinessCountry}
                      onSelect={(value) => setSelectedBusinessCountry(value)}
                      error={errors?.businessCountry?.message}
                      register={register("businessCountry", {
                        // required: "Please select Business Country.",
                      })}
                    />
                  </Grid> */}
                  {/* {pathname !== "/create-customer" && (
										<Fragment>
											<Grid item xs={12} sm={6}>
												<InputField
													label={"Password"}
													type={showPassword ? "text" : "password"}
													placeholder={"Password"}
													InputProps={{
														endAdornment: (
															<InputAdornment position="end">
																<IconButton edge="end" onClick={() => setShowPassword(!showPassword)}>
																	{showPassword ? (
																		<Visibility
																			sx={{
																				color: Colors.cloud,
																			}}
																		/>
																	) : (
																		<VisibilityOff
																			sx={{
																				color: Colors.cloud,
																			}}
																		/>
																	)}
																</IconButton>
															</InputAdornment>
														),
													}}
													error={errors?.password?.message}
													register={register("password", {
														required: pathname !== "/create-customer" ? "Please enter the password." : false,
														pattern: {
															value: passwordRegex,
															message:
																"Password contain minimum 8 characters, at least uppercase/lowercase letter, number and special character",
														},
													})}
												/>
											</Grid>
											<Grid item xs={12} sm={6}>
												<InputField
													label={"Confirm Password"}
													type={showConfirmPassword ? "text" : "password"}
													placeholder={"Confirm Password"}
													InputProps={{
														endAdornment: (
															<InputAdornment position="end">
																<IconButton edge="end" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
																	{showConfirmPassword ? (
																		<Visibility
																			sx={{
																				color: Colors.smokeyGrey,
																			}}
																		/>
																	) : (
																		<VisibilityOff
																			sx={{
																				color: Colors.smokeyGrey,
																			}}
																		/>
																	)}
																</IconButton>
															</InputAdornment>
														),
													}}
													error={errors?.confirmPassword?.message}
													register={register("confirmPassword", {
														required: pathname !== "/create-customer" ? "Please enter the confirm password." : false,
														validate: (value) => value === password.current || "Confirm password does not match.",
													})}
												/>
											</Grid>
										</Fragment>
									)} */}

                  <Grid item xs={12} sm={6}>
                    <InputField
                      label={"Mobile :"}
                      placeholder={"Mobile "}
                      type={"number"}
                      error={errors?.mobile?.message}
                      register={register("mobile", {
                        required: "please enter mobile number",
                        // pattern: {
                        //   value: /^05[0-9]{8}$/,
                        //   message:
                        //     "Please enter a valid UAE mobile number (starting with 05 and 8 digits).",
                        // },
                      })}
                    />
                  </Grid>

                  <Grid item xs={6} sm={6}>
                    <InputField
                      label={"Email"}
                      type={"email"}
                      placeholder={"Email Address"}
                      error={errors?.email?.message}
                      register={register("email", {
                        required: false,
                        pattern: {
                          value: emailRegex,
                          message: "Please enter a valid email.",
                        },
                      })}
                    />
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <InputField
                      label={"TRN #"}
                      type={"text"}
                      placeholder={"TRN #"}
                      error={errors?.trn?.message}
                      register={register("trn", {
                        required: false,
                      })}
                    />
                  </Grid>
                    <Grid item xs={6} sm={6}>
                    <InputField
                      label={"Address"}
                      type={"text"}
                      placeholder={"Address"}
                      error={errors?.address?.message}
                      register={register("address", {
                        required: false,
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputField
                      label={"Authorized Person Name"}
                      inputProps={{ maxLength: 30 }}
                      placeholder={"Authorized Person Name"}
                      error={errors?.apName?.message}
                      register={register("apName")}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputField
                      label={"Mobile (Authorized Person) :"}
                      placeholder={"Mobile (Authorized Person) "}
                      type={"number"}
                      error={errors?.apMobile?.message}
                      register={register("apMobile", {
                        required: false,
                        // pattern: {
                        //   value: /^05[0-9]{8}$/,
                        //   message:
                        //     "Please enter a valid UAE mobile number (starting with 05 and 8 digits).",
                        // },
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputField
                      label={"Identity Document"}
                      placeholder={"Identity Document"}
                      inputProps={{ maxLength: 30 }}
                      error={errors?.apDocumentName?.message}
                      register={register("apDocumentName")}
                    />
                  </Grid>
                  {customerTypes?.customerType?.id !== 3 ? (
                    <Grid item xs={12} sm={6}>
                      <DatePicker
                        label={"Passport Expiry Date"}
                        value={passportExp}
                        // disablePast={true}
                    
                        register={register("passportExp", {
                          required: false,
                        })}
                        // errorMessage={"Please enter you passport expiry date."}
                        onChange={(date) => handlePassportDate(date)}
                      />
                    </Grid>
                  ) : (
                    ""
                  )}
                  {/* <Grid item xs={12} sm={6}>
										<Typography variant="body1" sx={{ color: Colors.charcoalGrey, mb: 1 }}>
											Identity / Power of Attorney Attach
										</Typography>
										<UploadFile
											accept={allowFilesType}
											register={register("document", {
												onChange: (e) => handleUploadDocument(e),
											})}
										/>
									</Grid> */}
                  {/* <Grid item xs={12} sm={6}>
										{documentsDetail.length > 0 && (
											<Fragment>
												<Typography variant="body1" sx={{ color: Colors.charcoalGrey, mb: 1 }}>
													Uploaded Files
												</Typography>
												<Box
													sx={{
														maxHeight: 300,
														overflow: "auto",
														pr: 1,
													}}
												>
													{documentsDetail?.map((item, index) => (
														<Uploading
															key={index}
															data={item}
															uploadedMBs={uploadedSize}
															progress={progress}
															removeDoc={() => removeDoc(index)}
														/>
													))}
												</Box>
											</Fragment>
										)}
									</Grid> */}

                  {customerTypes?.customerType?.id !== 3 ? (
                    <Fragment>
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="body1"
                          sx={{ color: Colors.charcoalGrey, mb: 1 }}
                        >
                          Upload Passport Copy
                        </Typography>
                        <UploadFile
                          accept={allowFilesType}
                          error={errors?.passport?.message}
                          register={register("passport", {
                            required: false,
                            onChange: (e) =>
                              handleUploadDocument4(e, "passport"),
                          })}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        {/* <DatePicker
													label={"Passport Expiry Date"}
													value={passportExp}
													disablePast={true}
													error={errors?.passportExp?.message}
													register={register("passportExp", {
														required:
															false,
													})}
													errorMessage={"Please enter you passport expiry date."}
													onChange={(date) => handlePassportDate(date)}
												/> */}
                        {passportDetail.length > 0 && (
                          <Typography
                            variant="body1"
                            sx={{
                              color: Colors.charcoalGrey,
                              my: 1,
                            }}
                          >
                            Uploaded Files
                          </Typography>
                        )}
                        <Box
                          sx={{
                            maxHeight: 300,
                            overflow: "auto",
                            pr: 1,
                          }}
                        >
                          {passportDetail?.map((item, index) => (
                            <Uploading
                              key={index}
                              data={item}
                              uploadedSize={uploadedSize4}
                              progress={progress4}
                              removeDoc={() => removeDoc4("passport")}
                            />
                          ))}
                        </Box>
                      </Grid>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <Grid item xs={12} sm={6}>
                        <InputField
                          label={"Trade License #"}
                          placeholder={"Trade License"}
                          error={errors?.tradeLicense?.message}
                          register={register("tradeLicense", {
                            required:
                              customerTypes?.customerType?.id === 3
                                ? "Please enter your trade license."
                                : false,
                          })}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <DatePicker
                          label={"Trade License Expiry Date"}
                          value={tradeExp}
                          disablePast={true}
                          error={
                            customerTypes?.customerType?.id === 3
                              ? tradeExp === null || tradeExp === "invalid"
                                ? true
                                : false
                              : false
                          }
                          errorMessage={
                            "Please enter you trade license expiry date."
                          }
                          onChange={(date) => handleTradeDate(date)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputField
                          label={"VAT Certificate #"}
                          placeholder={"VAT Certificate"}
                          error={errors?.vatCertificate?.message}
                          register={register("vatCertificate", {
                            required:
                              customerTypes?.customerType?.id === 3
                                ? "Please enter your VAT certificate."
                                : false,
                          })}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <DatePicker
                          label={"VAT Expiry Date"}
                          value={vatExp}
                          disablePast={true}
                          error={
                            customerTypes?.customerType?.id === 3
                              ? vatExp === null || vatExp === "invalid"
                                ? true
                                : false
                              : false
                          }
                          errorMessage={"Please enter you VAT expiry date."}
                          onChange={(date) => handleVatDate(date)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="body1"
                          sx={{ color: Colors.charcoalGrey, mb: 1 }}
                        >
                          Upload Trade License
                        </Typography>
                        <UploadFile
                          accept={allowFilesType}
                          error={errors?.license?.message}
                          register={register("license", {
                            required: "Please upload your trade license.",
                            onChange: (e) =>
                              handleUploadDocument4(e, "license"),
                          })}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        {licenseDetail.length > 0 && (
                          <Typography
                            variant="body1"
                            sx={{
                              color: Colors.charcoalGrey,
                              mb: 1,
                            }}
                          >
                            Uploaded Files
                          </Typography>
                        )}
                        <Box
                          sx={{
                            maxHeight: 300,
                            overflow: "auto",
                            pr: 1,
                          }}
                        >
                          {licenseDetail?.map((item, index) => (
                            <Uploading
                              key={index}
                              data={item}
                              uploadedSize={uploadedSize4}
                              progress={progress4}
                              removeDoc={() => removeDoc4("license")}
                            />
                          ))}
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography
                          variant="body1"
                          sx={{ color: Colors.charcoalGrey, mb: 1 }}
                        >
                          Upload VAT Certificate
                        </Typography>
                        <UploadFile
                          accept={allowFilesType}
                          error={errors?.certificate?.message}
                          register={register("certificate", {
                            required: "Please upload your VAT certificate.",
                            onChange: (e) =>
                              handleUploadDocument4(e, "certificate"),
                          })}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        {certificateDetail.length > 0 && (
                          <Typography
                            variant="body1"
                            sx={{
                              color: Colors.charcoalGrey,
                              mb: 1,
                            }}
                          >
                            Uploaded Files
                          </Typography>
                        )}
                        <Box
                          sx={{
                            maxHeight: 300,
                            overflow: "auto",
                            pr: 1,
                          }}
                        >
                          {certificateDetail?.map((item, index) => (
                            <Uploading
                              key={index}
                              data={item}
                              uploadedSize={uploadedSize4}
                              progress={progress4}
                              removeDoc={() => removeDoc4("certificate")}
                            />
                          ))}
                        </Box>
                      </Grid>
                    </Fragment>
                  )}
                  <Grid item xs={12} sm={6}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.charcoalGrey, mb: 1 }}
                    >
                      Upload Customer Picture
                    </Typography>
                    <UploadFile
                      accept={allowOnlyImage}
                      error={errors?.picture?.message}
                      register={register("picture", {
                        onChange: (e) => handleUploadDocument4(e, "picture"),
                      })}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {pictureDetail.length > 0 && (
                      <Typography
                        variant="body1"
                        sx={{ color: Colors.charcoalGrey, mb: 1 }}
                      >
                        Uploaded Files
                      </Typography>
                    )}
                    <Box sx={{ maxHeight: 300, overflow: "auto", pr: 1 }}>
                      {pictureDetail?.map((item, index) => (
                        <Uploading
                          key={index}
                          data={item}
                          uploadedSize={uploadedSize4}
                          progress={progress4}
                          removeDoc={() => removeDoc4("picture")}
                        />
                      ))}
                    </Box>
                  </Grid>
                  {/* <Grid item xs={12} sm={12}>
										<Checkbox checked={isAccept} onChange={() => setOpenTerms(true)} />
										<Typography
											component={"span"}
											variant="body2"
											sx={{
												color: Colors.black,
												fontFamily: FontFamily.NunitoRegular,
												mb: 1,
											}}
										>
											By creating this account, I accept the&nbsp;
											<Typography
												component={"span"}
												variant="body2"
												onClick={() => setOpenTerms(true)}
												sx={{
													textDecoration: "underline",
													cursor: "pointer",
													color: Colors.primary,
													fontFamily: FontFamily.NunitoRegular,
													mb: 1,
												}}
											>
												terms & conditions.
											</Typography>
										</Typography>
									</Grid> */}
                  <Grid item xs={12} sx={{ mt: 2, textAlign: "right" }}>
                    <PrimaryButton
                      title="Submit"
                      type="submit"
                      loading={loading}
                      disabled={!isAccept}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
        </Grid>
      )}
    </Fragment>
  );
}

export default EditCustomer;
